import React from 'react'
import { Button, Card } from 'react-bootstrap'
import FloatingNumpad from 'components/FloatingNumpad'
import If from 'components/If'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import './style.css'

const PrintingRow = ({
	orderId,
	customerName,
	onPrintLabels
}) => {
	const [showPrintAmount, setShowPrintAmount] = React.useState(false)
	const [labelCount, setLabelCount] = React.useState('1')
	const [orderToPrint, setOrderToPrint] = React.useState('')

	const onChangeNumpadValue = (value) => {
		setLabelCount(value)
	}

	const clickPrintLabels = (orderId) => {
		setLabelCount('1')
		setOrderToPrint(orderId)
		setShowPrintAmount(true)
	}

	const onCloseNumpad = () => {
		setOrderToPrint('')
		setShowPrintAmount(false)
	}

	const onConfirmPrint = () => {
		const labelCountInt = Number(labelCount)
		if (Number.isNaN(labelCountInt) || labelCountInt <= 0) {
			return
		}

		setShowPrintAmount(false)
		onPrintLabels(orderToPrint, labelCountInt)
	}

	const items = [
		{
			key: 1,
			condition: true,
			label: 'Order Id:',
			value: orderId,
		},
		{
			key: 2,
			condition: true,
			label: 'Customer:',
			value: customerName,
		},
	]

	return (
		<div className="printingrow">
			<Card.Body
				className={classNames()}
			>
				{items.map(
					(item, index) =>
						item.condition && (
							<div
								key={item.key}
								className='item row'
							>
								{item.label}
								<div className="info">{item.value}</div>
							</div>
						),
				)}

				<div className={'printingBt row'}>
					<Button onClick={() => clickPrintLabels(orderId)}>
						Print Label
					</Button>
				</div>

			</Card.Body>
			<If condition={showPrintAmount}>
				<div>
					<FloatingNumpad
						headerText={'Enter Number of Labels'}
						closeOutSide={true}
						text={labelCount}
						onChange={onChangeNumpadValue}
						onClose={onCloseNumpad}
						onSend={onConfirmPrint}
						onClear={() => setLabelCount('')}
						hideExtraButton={true}
						showStockButton={false}
					/>
				</div>
			</If>
		</div >
	)
}

PrintingRow.propTypes = {
	orderId: PropTypes.number.isRequired,
	customerName: PropTypes.string.isRequired,
	onPrintLabels: PropTypes.func.isRequired,
}

export default PrintingRow
